/**
 * Legal-document (Terms of Service + Privacy Policy) consent constants.
 *
 * SINGLE SOURCE OF TRUTH: the canonical Terms + Privacy are hosted on the marketing
 * website; the app sign-up LINKS to them and carries NO embedded legal copy. Non-
 * contradiction between app and website holds by construction. (This replaces the old
 * in-app /terms TermsPage, which embedded a divergent draft copy — retired 2026-07-02.)
 *
 * VERSION AUTHORITY: the consent version recorded against a user is server-authoritative —
 * stamped by the backend PostConfirmation trigger (sync_user.py) from SAM env vars, never
 * trusted from the client (BUG-20260630-114135). The version/date constants below are for
 * DISPLAY ONLY and MUST be kept in lockstep with the backend env vars
 * (TERMS_VERSION / TERMS_EFFECTIVE_DATE / PRIVACY_VERSION / PRIVACY_EFFECTIVE_DATE) and with
 * what terms.html / privacy.html actually state. Terms and Privacy are versioned
 * INDEPENDENTLY — source each from its own document, never copy one across to the other.
 *
 * HARD GATE: these v1.0 values must only ship to prod once terms.html AND privacy.html are
 * actually published (off noindex). Recording consent to a not-yet-live document manufactures
 * defective legal evidence.
 */

// Canonical, locked legal-document URLs (durable .html paths — no redirect machinery).
export const TERMS_URL = 'https://www.thinkotter.sg/terms.html' as const;
export const PRIVACY_URL = 'https://www.thinkotter.sg/privacy.html' as const;

// Display-only version + effective date, sourced independently from each document.
// Kept in lockstep with the backend SAM env vars of the same name.
export const TERMS_VERSION = 'v1.0' as const;
export const TERMS_EFFECTIVE_DATE = '2026-06-29' as const;
export const PRIVACY_VERSION = 'v1.0' as const;
export const PRIVACY_EFFECTIVE_DATE = '2026-06-29' as const;
